import { AxiosError } from 'axios';
import { AppRef } from 'common/modules/ReactShared';
import {
  tSupportedLanguagesResponse,
  tTargetLanguagesResponse,
  tWordDefinitionResponse
} from './types';
import { getApi, initNewApiInstance } from '../apiClient';

export async function getAllSupportedLanguages(): Promise<tSupportedLanguagesResponse> {
  const { data } = await getApi().get<tSupportedLanguagesResponse>(`/languages`);

  return data;
}

export async function getAllTargetLanguages(): Promise<tTargetLanguagesResponse> {
  const { data } = await getApi().get<tTargetLanguagesResponse>(`/languages/active`);

  return data;
}

function customErrorHandler(error: AxiosError): Promise<any> {
  return Promise.reject(error);
}

export async function getWordDefinition(text: string): Promise<tWordDefinitionResponse> {
  try {
    const { data } = await initNewApiInstance({
      onRejectResponse: customErrorHandler
    }).get(`${AppRef.current?.constants?.ORDNETT_SEARCH_ENDPOINT || ''}/search`, {
      withCredentials: true,
      params: {
        phrase: text,
        language: 'no',
        searchmode: 'headword',
        omitspellcheck: true,
        outputformat: 'html',
        lemmasearch: true
      }
    });

    return data;
  } catch (e) {
    // Do nothing
  }

  return {
    result: []
  };
}
